(function($) {
  'use strict';
  
  function ReadmoreEngraving() {
    var textHeight = $('.engraving-description .center-content').outerHeight();
    $('.engraving-description .center-content').css('height', '100px');
    
    $('#ReadMoreEngraving').click(function() {
      $(this).fadeOut( 0, function () {
        $(this).text(($(this).text() == 'Read less -') ? 'Read more +' : 'Read less -').fadeIn( 0 );
      })
      
      $('.engraving-description .center-content').toggleClass('full');
      
      if ($('.engraving-description .center-content').hasClass('full')) {
        $('.engraving-description .center-content').css('height', textHeight);
      } else {
        $('.engraving-description .center-content').css('height', '100px');
      }
    });
  }
  
  function SingleProductShare() {
    var wdWidth = $(window).width();
    if (wdWidth > 768) {
      $('.share-button, #social-sharing').mouseover(function() {
        $('#social-sharing').addClass('active');
      });

      $('.share-button, #social-sharing').mouseout(function() {
        $('#social-sharing').removeClass('active');
      });
    }
    
    $('.share-button').click(function() {
      $('#social-sharing').toggleClass('active');
    });
  }
  
  function mainSlider() {
    var $slideshow = $('.home-slider');
    $slideshow.owlCarousel({
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      mouseDrag : false,
      items: 1,
      margin: 0,
      stagePadding: 0,
      smartSpeed:450,
      nav : false,
      loop: true,
      lazyContent : true,
      autoplay : true,
      autoplayTimeout : 5000
    });
  }
  function homeFPc() {
    if($(".home-featured-products-wrapper.crsl").length > 0) {
      var $slideshow = $('.home-featured-products-wrapper.crsl .hfp-content');
      $slideshow.owlCarousel({
        loop: true,
        lazyContent: true,
        margin: 0,
        nav: true,
        dots: true,
        responsive:{
          0:{
              items:2
          },
          1024: {
            items: 4
          }
        }
      });
    }
  }

  function relatedSlider(){
    $('.related-products-items.owl-carousel').owlCarousel({
      loop:false,
      margin: 15,
      nav: true,
      dots: false,
      lazyLoad:true,
      responsiveClass:true,

      responsive:{
        0:{
          items:2,
          margin:5,
          nav:true
        },
        600:{
          items:3,
          margin:10,
          nav:true
        },
        1000:{
          items:3,
          nav:true
        }
      }
    })
  }

 $('.wallsmack-collection-slider').owlCarousel({
      loop:false,
      margin: 15,
      nav: true,
      dots: false,
      lazyLoad:true,
      responsiveClass:true,

      responsive:{
        0:{
          items:2,
          margin:5,
          nav:true
        },
        600:{
          items:2,
          margin:10,
          nav:true
        },
        1000:{
          items:4,
          nav:true
        }
      }
    });

$('.collection-reels-slider').owlCarousel({
      loop:false,
      margin: 15,
      nav: true,
      dots: false,
      lazyLoad:true,
      responsiveClass:true,
      slideTransition: 'linear',
      smartSpeed: 500,
      fluidSpeed:true,
      responsive:{
        0:{
          items:4,
          margin:5,
          nav:true
        },
        600:{
          items:4,
          margin:10,
          nav:false
        },
        1000:{
          items:10,
          nav:true
        }
      }
    });
   $('.prdts-sld').owlCarousel({
      loop:false,
      margin: 15,
      nav: true,
      dots: false,
      lazyLoad:true,
      responsiveClass:true,

      responsive:{
        0:{
          items:1,
          margin:5,
          nav:true
        },
        600:{
          items:2,
          margin:10,
          nav:true
        },
        1000:{
          items:4,
          nav:true
        }
      }
    })
  
  function sticky() {
    $('.site-header').stickUp();
    //     $('.product-single__left-wrapper').stickUp({
    //       topMargin : '100px',
    //       keepInWrapper:!0,
    //       wrapperSelector: ".product-single",
    //       disableOn : function(){
    //         if( $(window).width() < 768 )
    //           return false;
    //         return true;
    //       }
    //     });


    //     $('.product-single__submit').stickUp({
    //       disableOn : function(){
    //         if( $(window).width() > 768 )
    //           return false;
    //         return true;
    //       }
    //     });
  }

  
  /*=================== Countdown ===================*/
  window.onload = function(e){
    var $saleBarTimer = $('.sale-bar__timer');
    
    var clockDate = $saleBarTimer.data('date'),
        clockTime = $saleBarTimer.data('time'),
        eventTime = moment(clockDate+ ' ' +clockTime, 'MM-DD-YYYY HH:mm:ss U').unix(),
        currentTime = moment().unix(),
        diffTime = eventTime - currentTime,
        duration = moment.duration(diffTime * 1000, 'milliseconds'),
        interval = 1000;

    var $d = $('[data-timer-days]'),
        $h = $('[data-timer-hours]'),
        $m = $('[data-timer-minutes]'),
        $s = $('[data-timer-seconds]');

    setInterval(function(){
      currentTime = moment().unix()

      duration = moment.duration(duration.asMilliseconds() - interval, 'milliseconds');
      var d = moment.duration(duration).days(),
          h = moment.duration(duration).hours(),
          m = moment.duration(duration).minutes(),
          s = moment.duration(duration).seconds();

      d = $.trim(d).length === 1 ? '0' + d : d;
      h = $.trim(h).length === 1 ? '0' + h : h;
      m = $.trim(m).length === 1 ? '0' + m : m;
      s = $.trim(s).length === 1 ? '0' + s : s;

      $d.text(d);
      $h.text(h);
      $m.text(m);
      $s.text(s);

      if (eventTime - currentTime == 0) {
        $('[data-promo-timer-close]').trigger('click');
      }
      
    }, interval);
  };
  /* end Countdown */

  

  function fpcSlideshow() {
    $('.fpc-slideshow-wrap').owlCarousel({
      loop:true,
      items: 6,
      center:true,
      nav: true,
      dots: false,
      responsiveClass:true,
      autoplay: 3000,
      responsive:{
        0:{
          items: 2
        },
        769:{
          items: 4
        },
        1200:{
          items: 6
        }
      }
    });
  }
  
  function fpcSlideshowPopup() {
    $('.fpc-slideshow-wrap, .page-gallery__items').magnificPopup({
      delegate: 'a',
      type: 'image',
      tLoading: 'Loading image #%curr%...',
      mainClass: 'mfp-img-mobile contest-page-mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
      }
    });
  }
  
  function fpcShopMoreBtn() {
    $('.fpc-products .btn').click(function() {
      $('.fpc-products .button-wrap').hide();
      $('.fpc-products .product-grid__item').show();
    });
  }

  function fpcCriteria() {
    $('.fpc-panel-of-judges .criteria-btn').each(function() {
      $(this).click(function(e) {
        $('.fpc-panel-of-judges .criteria-content').removeClass('visible');
        $(this).next().addClass('visible');
        e.stopPropagation();
      });
    });
    
    $('.fpc-panel-of-judges .close-btn').click(function() {
      $('.fpc-panel-of-judges .criteria-content').removeClass('visible');
    });
    
    $(document).click(function() {
      $('.fpc-panel-of-judges .criteria-content').removeClass('visible');
    });
    
    $('.fpc-panel-of-judges .criteria-content').click(function(e) {
      e.stopPropagation();
    });
  }

  function loadMore() {
    $('.page-block__products-loadmore').each(function (index, element) {
      var $this = $(this);
      var settings = {
        loadMoreContainer:  $this.find('.grid-uniform'),
        loadMoreItem:  $this.find('.product-grid__item'),
        loadMoreLimit:  $this.data('limit'),
      }

      if ($this.length) {
        var wdWidth = $(window).width();
        if (wdWidth > 768) {
          $(settings.loadMoreContainer).simpleLoadMore({
            item: settings.loadMoreItem,
            count: settings.loadMoreLimit,
            itemsToLoad: (settings.loadMoreLimit) / 2,
            btnHTML: '<div class="grid__item text-center"><a href="#" class="btn load-more__btn">Show More +</a></div>'
          });
        } else {
           $(settings.loadMoreContainer).simpleLoadMore({
            item: settings.loadMoreItem,
            count: settings.loadMoreLimit - 4,
            itemsToLoad: (settings.loadMoreLimit) / 5,
            btnHTML: '<div class="grid__item text-center"><a href="#" class="btn load-more__btn">Show More +</a></div>'
          });
        }

      }
    })
  }
  
  function pageProductSlider() {
    $('.page-block__collection').each(function (index, element) {
      var $this = $(this);
      var settings = {
        productSlider:  $this.find('.page-block__products-slider')
      }

      if ($this.length) {
        $(settings.productSlider).owlCarousel({
          loop:false,
          items: 4,
          center: false,
          nav: true,
          dots: false,
          responsiveClass:true,
          autoplay: false,
          responsive:{
            0:{
              items: 2
            },
            769:{
              items: 2
            },
            1200:{
              items: 3
            }
          }
        });
      }
    })
  }

  $(document).ready(function() {
    sticky();
    mainSlider();
    relatedSlider();
    SingleProductShare();
    ReadmoreEngraving();
    fpcSlideshow();
    fpcSlideshowPopup();
    fpcShopMoreBtn();
    fpcCriteria();
    homeFPc();
    loadMore();
    pageProductSlider();
  });

})(jQuery);
